/**
 * 自定义简单解密工具类 (无需外部 Key)
 * 对应后端的加密逻辑，确保前端能够解密并展示原始内容
 */

// 混淆偏移量序列 (必须与后端一致)
const OFFSET_SEQUENCE = [13, 7, 21, 5, 11, 19, 3, 17];

/**
 * UTF-8 安全的 Base64 编码
 */
const b64Encode = (str: string): string => {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) => {
    return String.fromCharCode(parseInt(p1, 16));
  }));
};

/**
 * UTF-8 安全的 Base64 解码
 */
const b64Decode = (str: string): string => {
  return decodeURIComponent(Array.prototype.map.call(atob(str), (c: string) => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
};

/**
 * 加密字符串 (前端主要用于本地存储或其他场景，逻辑与后端同步)
 */
export const encrypt = (text: string): string => {
  if (!text) return '';
  
  // 1. Base64 预处理
  const base64 = b64Encode(text);
  
  // 2. 字符偏移与混淆
  let result = '';
  for (let i = 0; i < base64.length; i++) {
    const charCode = base64.charCodeAt(i);
    const offset = OFFSET_SEQUENCE[i % OFFSET_SEQUENCE.length];
    result += String.fromCharCode(charCode + offset);
  }
  
  // 3. 再次 Base64 包装
  return b64Encode(result);
};

/**
 * 解密字符串
 */
export const decrypt = (encryptedText: string): string => {
  if (!encryptedText) return '';
  
  try {
    // 1. 第一层 Base64 解码
    const firstDecode = b64Decode(encryptedText);
    
    // 2. 逆向字符偏移
    let result = '';
    for (let i = 0; i < firstDecode.length; i++) {
      const charCode = firstDecode.charCodeAt(i);
      const offset = OFFSET_SEQUENCE[i % OFFSET_SEQUENCE.length];
      result += String.fromCharCode(charCode - offset);
    }
    
    // 3. 最终 Base64 解码还原原始内容
    return b64Decode(result);
  } catch (error) {
    console.error('Decryption failed:', error);
    return '';
  }
};
